import * as React from "react";
const SvgPoundGreen = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={21}
    height={21}
    fill="none"
    {...props}
  >
    <path
      stroke="#389C7B"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M10.01 19.27a9.26 9.26 0 1 0 0-18.52 9.26 9.26 0 1 0 0 18.52"
    />
    <path
      stroke="#389C7B"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M9.323 11.01c-.625 1.458-1.562 2.917-2.812 3.5h5.937s.938 0 1.563-.583m-2.5-2.917h-5.5m7-2.75a2.75 2.75 0 1 0-2.75 2.75"
    />
  </svg>
);
export default SvgPoundGreen;
